module.exports = __webpack_public_path__ + "static/livestreaming-7-6230bbb90e0c99996f5dfd873da1f860.png";